export const COLORS={
    Primary :"#AC6FFA"
}